<template>
    <advertising-modal-advanced-config-captive-forms-filter-table :captive-forms-list="list"
                                                                  :loading="loading"
                                                                  @input="emitInput"
                                                                  :value="value"/>
  </template>
  
<script>
import AdvertisingModalAdvancedConfigCaptiveFormsFilterTable from "./table/AdvertisingModalAdvancedConfigCaptiveFormsFilterTable.vue";
import { cloneDeep } from 'lodash'
  
export default {
    components: {
        AdvertisingModalAdvancedConfigCaptiveFormsFilterTable
    },
  
    data() {
      return {};
    },  

    props: {
      value: {
        type: Array,
      },
      list: {
        type: Array
      },
      loading: {
        type: Boolean
      }
    },    
  
    methods: {           
      emitInput(val) {
        let value = cloneDeep(this.value);
        if(val.action === "select") {
          value.push(val.id)
        } else {
          value = value.filter(item => item !== val.id)          
        }
        this.$emit("input", value)
      }      
    },   
    
  };
</script>
  
<style lang="scss" scoped>
  .captive-form-list {
    ::v-deep .v-table__overflow {
      overflow: visible;
    }
  }
</style>